import { render, staticRenderFns } from "./mdc-top-app-bar-action-item.vue?vue&type=template&id=720c58a8&"
import script from "./mdc-top-app-bar-action-item.vue?vue&type=script&lang=ts&"
export * from "./mdc-top-app-bar-action-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports